import { isNil } from "ramda";
import { parseXmlDateTime } from "../utility/date.helpers";

const $ = window.jQuery;

const dateFormats = {
    singleDigitDay: "d",
    twoDigitDay: "dd",
    digitDayOfYear: "o",
    threeDigitDayOfYear: "oo",
    shortDayName: "D",
    longDayName: "DD",
    singleDigitMonth: "m",
    twoDigitMonth: "mm",
    shortMonthName: "M",
    longMonthName: "MM",
    twoDigitYear: "y",
    fourDigitYear: "yy"
};

const localeCodes = {
    1078: "af",
    1052: "sq",
    5121: "ar-DZ",
    15361: "ar",
    3073: "ar",
    2049: "ar",
    11265: "ar",
    13313: "ar",
    12289: "ar",
    4097: "ar",
    6145: "ar",
    8193: "ar",
    16385: "ar",
    1025: "ar",
    10241: "ar",
    7169: "ar",
    14337: "ar",
    9217: "ar",
    1067: "hy",
    2092: "az",
    1068: "az",
    1069: "eu",
    1059: "be",
    2117: "bn",
    5146: "bs",
    1026: "bg",
    1027: "ca",
    2052: "zh-CN",
    3076: "zh-HK",
    5124: "zh-CN",
    4100: "zh-CN",
    1028: "zh-TW",
    1050: "hr",
    1029: "cs",
    1030: "da",
    2067: "nl-BE",
    1043: "nl",
    3081: "en-AU",
    10249: "",
    4105: "",
    9225: "",
    2057: "en-GB",
    16393: "",
    6153: "",
    8201: "",
    5129: "en-NZ",
    13321: "",
    7177: "",
    11273: "",
    1033: "",
    12297: "",
    1061: "et",
    1071: "mk",
    1080: "fo",
    1065: "fa",
    1035: "fi",
    2060: "fr",
    11276: "fr",
    3084: "fr-CA",
    9228: "fr",
    12300: "fr",
    1036: "fr",
    5132: "fr",
    13324: "fr",
    6156: "fr",
    14348: "fr",
    10252: "fr",
    4108: "fr-CH",
    7180: "fr",
    1110: "gl",
    1079: "ka",
    3079: "de",
    1031: "de",
    5127: "de",
    4103: "de",
    2055: "de",
    1032: "el",
    1037: "he",
    1081: "hi",
    1038: "hu",
    1039: "is",
    1057: "id",
    1040: "it",
    2064: "it-CH",
    1041: "ja",
    1087: "kk",
    1107: "km",
    1042: "ko",
    1062: "lv",
    1063: "lt",
    2110: "ms",
    1086: "ms",
    1100: "ml",
    1044: "nb",
    2068: "nn",
    1045: "pl",
    1046: "pt-BR",
    2070: "pt",
    1047: "rm",
    2072: "ro",
    1048: "ro",
    1049: "ru",
    2073: "ru",
    3098: "sr",
    2074: "sr",
    1051: "sk",
    1060: "sl",
    11274: "es",
    16394: "es",
    13322: "es",
    9226: "es",
    5130: "es",
    7178: "es",
    12298: "es",
    17418: "es",
    4106: "es",
    18442: "es",
    2058: "es",
    19466: "es",
    6154: "es",
    15370: "es",
    10250: "es",
    20490: "es",
    1034: "es",
    14346: "es",
    8202: "es",
    2077: "sv",
    1053: "sv",
    1097: "ta",
    1054: "th",
    1055: "tr",
    1058: "uk",
    1066: "vi",
    1106: "cy-GB"
};

const getDatePickerRegionalFormat = (locale) =>
    isNil(locale) ? null : $.datepicker.regional[locale];


const parseDateSafe = (dateString) => {
    try {
        return parseXmlDateTime(dateString);
    } catch (e) {
        console.error('Date parse error', e);

        return null;
    };
}

function qdDateFormatter() {

    function getDateFormatString(dateFormat) {
        if (dateFormat.match("yyyy")) {
            dateFormat = dateFormat.replace("yyyy", dateFormats.fourDigitYear);
        }
        else if (dateFormat.match("yy")) {
            dateFormat = dateFormat.replace("yy", dateFormats.twoDigitYear);
        }
        if (dateFormat.match("MMMM")) {
            dateFormat = dateFormat.replace("MMMM", dateFormats.longMonthName);
        }
        else if (dateFormat.match("MMM")) {
            dateFormat = dateFormat.replace("MMM", dateFormats.shortMonthName);
        }
        else if (dateFormat.match("MM")) {
            dateFormat = dateFormat.replace("MM", dateFormats.twoDigitMonth);
        }
        else if (dateFormat.match("M")) {
            dateFormat = dateFormat.replace("M", dateFormats.singleDigitMonth);
        }
        if (dateFormat.match("dddd")) {
            dateFormat = dateFormat.replace("dddd", dateFormats.longDayName);
        }

        return dateFormat;
    }

    function getDatePickerFormatString(dateFormat) {
        switch (dateFormat.toLowerCase()) {
            case "short date":
                return dateFormats.singleDigitMonth + "/" + dateFormats.singleDigitDay + "/" + dateFormats.fourDigitYear;

            case "long date":
                return dateFormats.longDayName + ", " + dateFormats.longMonthName + " " + dateFormats.twoDigitDay + ", " + dateFormats.fourDigitYear;

            case "year month":
                return dateFormats.longMonthName + ", " + dateFormats.fourDigitYear;
        }

        return getDateFormatString(dateFormat);
    }

    function useEnglishLocale(dateFormatString) {
        dateFormatString = dateFormatString.toLowerCase();

        return dateFormatString === "short date" ||
            dateFormatString === "long date" ||
            dateFormatString === "year month";
    }

    function getDateLocale(localeCode) {
        if (!localeCode) {
            return "";//return empty for English locale, for control without locale
        }

        var intLocaleCode = 0;
        try {
            intLocaleCode = parseInt(localeCode);
        } catch (e) {
            console.error("Unable to parse locale:" + localeCode)
            return null;
        }

        const foundLocaleCode = localeCodes[intLocaleCode];
        if (foundLocaleCode || foundLocaleCode === "") {
            return foundLocaleCode;
        }

        return null;
    }

    function getDatePickerFormatOptions(fmtAttrList) {
        var dateFormatString = fmtAttrList.dateFormat;

        return {
            dateFormat: dateFormatString ? getDatePickerFormatString(dateFormatString) : null,
            locale: !fmtAttrList.locale && useEnglishLocale(dateFormatString)
                ? ""
                : (fmtAttrList.locale ? getDateLocale(fmtAttrList.locale) : null)
        };
    }

    function formatDate(dateString, options) {
        if (!dateString || !options || !options.dateFormat || options.dateFormat === "none") {
            return dateString;
        }

        const date = parseDateSafe(dateString);
        
        if (!date) {
            return dateString;
        }

        const datePickerFormat = getDatePickerFormatOptions(options);
        const regionalFormat = getDatePickerRegionalFormat(datePickerFormat.locale);

        if (!regionalFormat) {
            return dateString;
        }

        //Return original date string, as it returns empty if it cannot format it
        return $.datepicker.formatDate(datePickerFormat.dateFormat, date, regionalFormat) || dateString;
    }

    return {
        formatDate,
        getDatePickerFormatOptions,
        getDatePickerRegionalFormat,
    };
}

export default qdDateFormatter;